(ns journal-app-client.views.special
  (:require [goog.object :as g]
            [cljs.pprint :refer [pprint]]
            [journal-app-client.utils.common :as common]
            [journal-app-client.utils.react :as react]
            [journal-app-client.utils.react-fiber :as react-fiber]
            [re-frame.core :as rf]))

(defn framed-card [{:keys [key index message-key message use-state style]}]
  (let [[state _] use-state
        show-cards? (:show-cards? state)
        show-current-card? (= message-key (:message-key state))]
    [:div
     {:key key
      :style (merge {:display         "flex"
                     :justify-content "center"
                     :align-items     "center"}
                    style)}
     [:img
      {:style {:position   "absolute"
               :height     "110vh"
               :min-width     "110vh"
               :object-fit "cover"
               :filter (case index
                         0 "hue-rotate(255deg)"
                         1 "hue-rotate(0deg)"
                         2 "hue-rotate(200deg)"
                         "scale(1) translateX(110vh)")
               :transform (if show-cards?
                            (if show-current-card?
                              "scale(1) translateX(0)"
                              (case index
                                0 "scale(1) translateX(-110vh)"
                                1 "scale(1) translateY(-110vh)"
                                2 "scale(1) translateX(110vh)"
                                "scale(1) translateX(110vh)"))
                            (case index
                              0 "scale(6) translateX(-110vh)"
                              1 "scale(6) translateY(0)"
                              2 "scale(6) translateX(110vh)"
                              "scale(6) translateX(110vh)"))
               :transition "transform calc(6 * var(--transition-duration)) ease"}
       :src   "images/flowers/flower-card.png"}]
     [:div
      {:style {:position         "absolute"
               :max-width        "60vh"
               :padding "1rem"
               :margin-bottom "1rem"
               :background-color "transparent"
               :transform        (if show-cards?
                                   (if show-current-card?
                                     "scale(1) translateX(0)"
                                     (case index
                                       0 "scale(1) translateX(-110vh)"
                                       1 "scale(1) translateY(-110vh)"
                                       2 "scale(1) translateX(110vh)"
                                       "scale(1) translateX(110vh)"))
                                   (case index
                                     0 "scale(0) translateX(-110vh)"
                                     1 "scale(0) translateY(0)"
                                     2 "scale(0) translateX(110vh)"
                                     "scale(0) translateX(110vh)"))
               :transition       "transform calc(6 * var(--transition-duration)) ease"}}
      [:h1.title
       {:style {:font-family "Dawning of a new Day"
                :font-size "8vh"
                :text-align "center"
                :color "black"}}
       (:title message)]
      [:p.subtitle
       {:style {:font-size "3vh"
                :color "black"}}
       (:subtitle message)]
      [:p.subtitle
       {:style {:font-size "3vh"
                :color "black"}}
       (:from message)]]]))

(defn mothers-day []
  (let [[state set-state] (react/use-state {:message-key       :shako
                                            :background-colors {:shako  "rgb(230 255 255)"
                                                                :papole "rgb(255 230 230)"
                                                                :tess   "rgb(230 255 230)"}})
        audio-ref (react/use-ref)
        window-size @(rf/subscribe [:window-size])
        aspect-ratio (/ (:width window-size) (:height window-size))
        show-cards? (:show-cards? state)
        play-music? (:play-music? state)
        message-key (:message-key state)
        messages [[:tess {:title    "Kjære mamma"
                          :subtitle "Gratulerer med morsdagen. ❤️ Håper du får en fin dag og koser deg ekstra masse! Veldig glad i deg ❤️"
                          :from     "Hilsen Tess😊"}]
                  [:shako {:title    "Gledelig morsdag!"
                           :subtitle "Disse blomstene er for deg. Jeg håper du har det skikkelig fint! 👍"
                           :from     "Hilsen Shako😊"}]
                  [:papole {:title    "Tusen takk!"
                            :subtitle "Du er en god og fin mamma, du fortjener alt godt og enda mer! Det gjør meg glad å se at du har det bra og har funnet fred i hverdagen. Veldig masse glad i deg."
                            :from     "Hilsen Papole😊"}]]
        background-color (get-in state [:background-colors message-key])]
    [:div
     {:style {:height     "100svh"
              :position "relative"
              :z-index "1"
              :overflow "hidden"
              :display "flex"
              :justify-content "center"
              :align-items "center"
              :background-color background-color
              :transition "background-color calc(6 * var(--transition-duration)) ease"}}
     (when show-cards?
       [:button.button
        {:style    {:position      "absolute"
                    :z-index       "2"
                    :border-radius "2000px"
                    :top           "1rem"
                    :right         "1rem"}
         :on-click #(do
                      (if play-music?
                        (.pause (.-current audio-ref))
                        (.play (.-current audio-ref)))
                      (set-state (assoc state :play-music? (not play-music?))))}
        [:span.icon
         (if play-music?
           [:i.fas.fa-volume-xmark]
           [:i.fas.fa-music])]])
     [:audio
      {:ref      audio-ref
       :controls false
       :on-ended (fn [event] (.play (.-target event)))}
      [:source {:src "sounds/background-music-just-relax.mp3" :type "audio/mpeg"}]]
     [:div
      {:type     "button"
       :style    {:position   "absolute"
                  :z-index    "2"
                  :transform  (if show-cards?
                                "translateY(100vh)"
                                "translateY(0)")
                  :transition "transform calc(6 * var(--transition-duration)) ease"}
       :on-click #(do
                    (.play (.-current audio-ref))
                    (set-state (assoc state :show-cards? true :play-music? true)))}
      [:h1.title {:style {:color "black"}}
       "Click me!😁"]]
     (into
       [:div.buttons
        {:style {:position   "absolute"
                 :bottom     "5vmin"
                 :z-index    "2"
                 :transform  (if show-cards?
                               "translateY(0)"
                               "translateY(100vh)")
                 :transition "transform calc(6 * var(--transition-duration)) ease"}}]
       (map-indexed
         (fn [index [m-k _]]
           (let [background-color (get-in state [:background-colors m-k])]
             [:button.button
              {:key      (str "button-" m-k "-" index)
               :style    {:min-width        "6rem"
                          :background-color (if (= message-key m-k) background-color "rgba(0,0,0,0.5)")
                          :color            (if (= message-key m-k) "black" background-color)
                          :text-transform   "capitalize"
                          :border-color     (if (= message-key m-k) background-color "black")}
               :on-click #(set-state (assoc state :message-key m-k))}
              (name m-k)]))
         messages))
     (into
       [:div]
       (map-indexed
         (fn [index [message-key message]]
           [framed-card
            {:key         (str "message-" message-key "-" index)
             :use-state   [state set-state]
             :index       index
             :message-key message-key
             :message     message}])
         messages))
     [:img
      {:style {:position   "fixed"
               :top        "50%"
               :left       "50%"
               :transform  "translate(-50%, -50%)"
               :filter     "brightness(1) saturate(1.5)"
               :transition "filter calc(4 * var(--transition-duration)) ease"
               :height     (if (<= (/ 1920 1280) aspect-ratio)
                             "auto"
                             "calc(110vh + 30px)")
               :max-width  "none"
               :width      (if (<= (/ 1920 1280) aspect-ratio)
                             "calc(110vw + 30px)"
                             "auto")}
       :src   "images/flowers/flower-border.png"}]
     [:img
      {:style {:position   "fixed"
               :top        "50%"
               :left       "50%"
               :transform  "translate(-50%, -50%) scale(-1)"
               :filter     "brightness(1) saturate(1.5)"
               :transition "filter calc(4 * var(--transition-duration)) ease"
               :height     (if (<= (/ 1920 1280) aspect-ratio)
                             "auto"
                             "calc(110vh + 30px)")
               :max-width  "none"
               :width      (if (<= (/ 1920 1280) aspect-ratio)
                             "calc(110vw + 30px)"
                             "auto")}
       :src   "images/flowers/flower-border.png"}]
     [:img
      {:style {:position "absolute"
               :left     "-6rem"
               :top   "-20rem"
               :width    "35rem"
               :filter "blur(0) brightness(1) saturate(1.5)"
               :transform (if show-cards?
                            "translate(-35rem,-35rem) rotate(45deg)"
                            "translate(0,0) rotate(45deg)")
               :transition "transform calc(6 * var(--transition-duration)) ease"}
       :src   "images/flowers/flower-pink.png"}]
     [:img
      {:style {:position "absolute"
               :left     "-16rem"
               :bottom   "-22rem"
               :width    "60rem"
               :filter   "brightness(1) saturate(1.5)"
               :transform (if show-cards?
                            "translate(-60rem,60rem)"
                            "translate(0,0)")
               :transition "transform calc(6 * var(--transition-duration)) ease"}
       :src   "images/flowers/flower-purple.png"}]
     [:img
      {:style {:position "absolute"
               :right     "-16rem"
               :top   "-24rem"
               :width    "60rem"
               :filter "brightness(1) saturate(1.5)"
               :transform (if show-cards?
                            "translate(60rem,-60rem) scale(-1)"
                            "translate(0,0) scale(-1)")
               :transition "transform calc(6 * var(--transition-duration)) ease"}
       :src   "images/flowers/flower-purple.png"}]
     [:img
      {:style {:position  "absolute"
               :right     "-6rem"
               :bottom    "-20rem"
               :width     "35rem"
               :filter "brightness(1) saturate(1.5)"
               :transform (if show-cards?
                            "translate(35rem,35rem) rotate(45deg) scale(-1)"
                            "translate(0,0) rotate(45deg) scale(-1)")
               :transition "transform calc(6 * var(--transition-duration)) ease"}
       :src   "images/flowers/flower-pink.png"}]
     [:div
      {:style {:position        "absolute"
               :inset           "0"
               :transform       "unset"
               :z-index "1"
               :display "flex"
               :justify-content "center"
               :align-items "center"}}]]))

(defn preload-3D-objects [] (react-fiber/preload "3D/special/flower-pot.glb"))

(defn sphere [& [props]]
  [react-fiber/drei-sphere
   (merge
     {:visible  true
      :position [0, 0, 0]}
     props)
   [:meshStandardMaterial {:color "blue"}]])

(defn box [& argv]
  (let [[props children] (common/argv->props-children argv)]
    (into
      [react-fiber/drei-box
       (merge
         {:position [0, 0, 0]}
         (dissoc props :mesh-props))
       [:meshStandardMaterial
        (:mesh-props props)]]
      children)))

(defn plane [& [props]]
  [react-fiber/drei-plane
   (merge
     {:receive-shadow true
      :position [0, 0, 0]
      :rotation [(/ Math/PI 2) 0, 0]}
     props)
   [:meshStandardMaterial {:color (:color props) :side react-fiber/double-side}]])

(defn flower-pot [props]
  (let [flower-pot-object (react-fiber/use-gltf "3D/special/flower-pot.glb")
        nodes (.-nodes flower-pot-object)
        materials (.-materials flower-pot-object)]
    [:group props
     [:mesh
      {:cast-shadow true :receive-shadow true
       :geometry    (.-geometry (.-POT nodes))
       :material (g/get materials "Material.002")
       :scale [0.83, 0.591, 0.83]}]
     [:group {:position [-0.044, 1.248, -0.124] :rotation [-0.356, -0.254, 0.183] :scale [0.089, 0.104, 0.09]}
      [:mesh {:cast-shadow true :receive-shadow true :geometry (.-geometry (.-Plane005 nodes)) :material (g/get materials "Material.005")}]
      [:mesh {:cast-shadow true :receive-shadow true :geometry (.-geometry (.-Plane005_1 nodes)) :material (g/get materials "Material.004")}]]
     [:mesh {:cast-shadow true :receive-shadow true :geometry (.-geometry (.-LEAVES nodes)) :material (g/get materials "Material.003")
             :position    [0.063, 0.661, -0.046] :rotation [0.199, -0.985, 0.166] :scale 0.285}]
     [:group {:position [0.128, 1.149, 0.053] :rotation [-1.672, -1.122, -1.641] :scale [0.09, 0.105, 0.09]}
      [:mesh {:cast-shadow true :receive-shadow true :geometry (.-geometry (.-Plane006 nodes)) :material (g/get materials "Material.005")}]
      [:mesh {:cast-shadow true :receive-shadow true :geometry (.-geometry (.-Plane006_1 nodes)) :material (g/get materials "Material.004")}]]
     [:group {:position [-0.135, 1.151, 0.091] :rotation [-2.715, -0.732, 2.655] :scale [0.087, 0.101, 0.087]}
      [:mesh {:cast-shadow true :receive-shadow true :geometry (.-geometry (.-Plane021 nodes)) :material (g/get materials "Material.005")}]
      [:mesh {:cast-shadow true :receive-shadow true :geometry (.-geometry (.-Plane021_1 nodes)) :material (g/get materials "Material.004")}]]
     [:mesh {:cast-shadow true :receive-shadow true :geometry (.-geometry (.-STEM nodes)) :material (g/get materials "Material.003")
             :position    [0, -0.051, 0] :rotation [(- Math/PI), 0.791, (- Math/PI)] :scale 1.076}]]))

(defn box-interior [props]
  (let [color (:color props)]
    [:group props
     [plane
      {:position [0 0 0]
       :scale    [25 25 25]
       :color    color}]
     [plane
      {:position [0 12.5 -12.5]
       :scale    [25 25 25]
       :rotation [Math/PI 0 0]
       :color    color}]
     [plane
      {:position [-12.5 12.5 0]
       :scale    [25 25 25]
       :rotation [Math/PI (/ Math/PI 2) 0]
       :color    color}]
     [plane
      {:position [12.5 12.5 0]
       :scale    [25 25 25]
       :rotation [Math/PI (/ Math/PI 2) 0]
       :color    color}]]))

(defn card [show-card?]
  [:group
   [:group
    {:scale (if show-card? 0 1)}
    [react-fiber/drei-text
     {:position   [0 0 0]
      :font-size  0.15
      :color      "black"
      :characters "abcdefghijklmnopqrstuvwxyzæøå0123456789!"}
     "Click on me!"]]
   [:group
    {:scale (if show-card? 1 0)}
    [box
     {:position   [0 0 -0.25]
      :scale      [1 1 0.1]
      :mesh-props {:transparent true
                   :opacity     0.9
                   :color       "white"}}]
    [react-fiber/drei-text
     {:position   [-0.45 0.45 0]
      :font-size  0.1
      :color      "black"
      :anchor-x   "left"
      :anchor-y   "top"
      :characters "abcdefghijklmnopqrstuvwxyzæøå0123456789!"}
     "Gledelig morsdag!"]
    [react-fiber/drei-text
     {:position   [-0.45 0.3 0]
      :font-size  0.075
      :color      "black"
      :anchor-x   "left"
      :anchor-y   "top"
      :characters "abcdefghijklmnopqrstuvwxyzæøå0123456789!"}
     (if show-card?
       "
 Disse blomstene er for deg.
 Jeg håper du har det
 skikkelig fint! ^^


 Hilsen Shako"
       "")]
    [box
     {:position   [0 0 -0.5]
      :scale      [1.05 1.05 0.1]
      :mesh-props {:transparent true
                   :opacity     0.25
                   :color       "#22d6c7"}}]]])

(defn animated-card [props]
  (let [[state set-state] (:use-state props)
        color (:color props)
        show-cards? (:show-cards? state)
        position (or (:position props) [0 -0.5 0.5])
        scale (or (:scale props) [1.25 1.5 0.1])
        mesh-springs (js->clj (react-fiber/use-spring #js{:scale    (clj->js (if show-cards? scale [0.5 0.5 0.1]))
                                                          :position (clj->js (if show-cards? [0 0 1] position))
                                                          :config   (.-wobbly react-fiber/spring-config)}))
        mesh-material-springs (js->clj (react-fiber/use-spring #js{:color   (if show-cards? "#42ffba" "#22d6c7")
                                                                   :opacity (if show-cards? 0.9 0.5)}))]
    (cljs.pprint/pprint show-cards?)
    [:group props
     [react-fiber/animated-mesh
      mesh-springs
      [card show-cards?]
      #_[react-fiber/animated-mesh-standard-material
       (merge mesh-material-springs {:transparent true})]]]))

(defn mothers-day-3d []
  (let [[state set-state] (react/use-state {})]
    [react-fiber/canvas
     {:shadows true
      :style   {:position         "absolute"
                :top      "0"
                :left     "0"
                :background-color "white"}}
     [react-fiber/environment
      {:files "3D/hdri/sandsloot_4k.hdr" :background false}]
     [:spotLight {:position    [5, 10, 10]
                  :angle       1
                  :penumbra    1
                  :intensity   50
                  :cast-shadow true
                  :shadow-bias -0.0001}]
     [react-fiber/perspective-camera
        {:make-default true :far 10000 :near 0.001 :fov 35
         :position     [0 0 5]}]
     [flower-pot
      {:position [0 -1 0]
       :on-click #(set-state (assoc state :show-cards? (not (:show-cards? state))))}]
     [flower-pot
      {:position [0.5 -1 -0.8]
       :rotation [0 (/ Math/PI 2) 0]}]
     [flower-pot
      {:position [-0.5 -1 -0.8]
       :rotation [0 (- (/ Math/PI 2)) 0]}]
     [plane
      {:position [0 -1 0]
       :scale    [35 25 25]}]
     [plane
      {:position [0 11.5 -3]
       :scale    [35 25 25]
       :rotation [Math/PI 0 0]}]
     [:f> animated-card {:use-state [state set-state]}]
     [react-fiber/orbit-controls
      {:enable-pan false
       :enable-zoom false
       :min-azimuth-angle (- (/ Math/PI 5))
       :max-azimuth-angle (/ Math/PI 5)
       :min-polar-angle (/ Math/PI 3)
       :max-polar-angle (/ Math/PI 1.8)}]
     (when goog.DEBUG
       [react-fiber/stats])]))

(defn view [props]
  (case (:sub-view props)
    :mothers-day-3d [:f> mothers-day-3d props]
    :mothers-day [:f> mothers-day props]
    [:f> mothers-day props]))